import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import { setCookieForMembers } from '../../../src/client/utils/cookie-for-members';
import config from '../../../src/client/config';
import getInsuranceTypeFromLocation from '../../../src/client/pages/insurance/utils/get-insurance-type-from-location';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import Head from '../../../src/utils/head';
import RedirectAdapter from '../../../src/client/utils/redirect-adapter';
import type { InsuranceTypeParamValue } from '../../../src/client/pages/insurance/types';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.CAR, INSURANCE_TYPES.HOME]);

export const getStaticProps = ({ params: { insuranceType } }: { params: { insuranceType: string } }) => ({
  props: { location: insuranceType },
});

const SALES_URL = config.get('sales:url');
const PORTAL_LOGIN_PAGE = config.get('open:portalUrl');
const API_TOKEN = config.get('open:apiToken');

const insuranceTypeMetadata: Partial<Record<InsuranceTypeParamValue, { title: string; description?: string }>> = {
  'car-insurance': { title: 'Log in to your car insurance account' },
  'home-insurance': { title: 'Log in to your home insurance account' },
};

type Props = {
  location: 'car-insurance' | 'home-insurance';
};

const CarAndHomeLoginPage = ({ location }: Props) => {
  const insuranceType = getInsuranceTypeFromLocation(location);
  const portalLoginWithParams = `${PORTAL_LOGIN_PAGE}/login?partner=${API_TOKEN}&redirect=${SALES_URL}`;
  const metadata = insuranceTypeMetadata[location];
  setCookieForMembers(insuranceType);
  return (
    <>
      {metadata && (
        <Head titleTemplate="%s - ahm insurance">
          <title>{metadata.title}</title>
          {metadata.description && <meta name="description" content={metadata.description} />}
        </Head>
      )}
      <RedirectAdapter to={portalLoginWithParams} />
    </>
  );
};

export default CarAndHomeLoginPage;
